(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-by-turbo"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    const tabs = document.querySelectorAll('.product__tabs');
    const tabsContent = document.querySelectorAll('.product__tabs-content');

    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        if (tab.id === 'tab2') {
          document.getElementById('tp-ingredientes').scrollIntoView({
            behavior: 'smooth',
          });
        }
      });
    });

    // tabs.forEach((tab) => {
    //   tab.addEventListener('click', function () {
    //     //remove active class on all tabs
    //     tabs.forEach((tab2) => {
    //       tab2.classList.remove('active');
    //     });
    //     //remove active class on all contents
    //     tabsContent.forEach((content) => {
    //       content.classList.remove('content_active');
    //     });

    //     //add active class on selected tab
    //     tab.classList.add('active');
    //     //add active class on selected content
    //     document.querySelector(`.${tab.id}`).classList.add('content_active');

    //     //Quando clicar na table cujo o id for "tab2" vai ancorar para div "tp-ingredientes"
    //     if (tab.id === 'tab2') {
    //       document.getElementById('tp-ingredientes').scrollIntoView({
    //         behavior: 'smooth',
    //       });
    //     }
    //   });
    // });

    const ingredients_links = document.querySelectorAll('.variant-ingredients');

    ingredients_links.forEach((link, index) => {
      link.addEventListener('click', function () {
        document.getElementById(`button${index + 1}`).click();
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-by-turbo"] && !Shopify.designMode) return;
  try {
    
  const modalSabor = document.getElementById('modal-novo-sabor');
  const modalPrimMao = document.getElementById('modal-primeira-mao');
  const btn = document.getElementById('newProductOptionsButton');
  btn.addEventListener('click', () => {
    modalSabor.style.display = 'flex';
  });

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const openModal = urlParams.get('modalOpen');
  if (openModal == true) {
    btn.click();
  }

  const sugestaoSaborInput = document.querySelector('#sugestao-sabor');
  const sendButton = document.querySelector('#novo-sabor-button');

  sugestaoSaborInput.addEventListener('input', (e) => {
    const options = document.querySelectorAll('input[type="radio"][name="contact[tags]"]:checked');
    if (sugestaoSaborInput.value.length > 0) {
      options[0].value = `outro, ${e.target.value}`;
      sendButton.disabled = false;
    } else {
      sendButton.disabled = true;
    }
  });

  sendButton.addEventListener('click', (event) => {
    let checked = document.querySelectorAll('input[type="radio"][name="contact[tags]"]:checked');
    if (checked[0].id === 'novo-sabor-opcao3') {
      const sugestaoTexto = sugestaoSaborInput.value;
      modalSabor.style.display = 'none';
      modalPrimMao.style.display = 'flex';
    } else {
      modalSabor.style.display = 'none';
      modalPrimMao.style.display = 'flex';
    }
    event.stopPropagation();
  });

  const fechaModalSabor = document.getElementById('novo-sabor-body');
  const fechaModalPrim = document.getElementById('primeira-mao-body');
  window.onclick = function (event) {
    if (event.target == fechaModalSabor || event.target == fechaModalPrim) {
      modalSabor.style.display = 'none';
      modalPrimMao.style.display = 'none';
    }
  };

  const formSaboresInputs = Array.from(document.querySelectorAll('input[name="contact[tags]"]'));
  formSaboresInputs.forEach((input) => {
    input.addEventListener('click', (event) => {
      var checked = document.querySelectorAll('input[name="contact[tags]"]:checked');
      sendButton.disabled = true;
      sugestaoSaborInput.disabled = true;
      if (checked.length > 0) {
        if (event.target.id === 'novo-sabor-opcao3') {
          sugestaoSaborInput.disabled = false;
        } else {
          sendButton.disabled = false;
        }
      }
    });
  });

  const emailTextInput = document.querySelector('#primeira-mao-email');
  emailTextInput.addEventListener('keyup', () => {
    if (document.getElementById('primeira-mao-email').value !== '') {
      document.querySelector('#primeira-mao-button').disabled = false;
    } else {
      document.querySelector('#primeira-mao-button').disabled = true;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-by-turbo"] && !Shopify.designMode) return;
  try {
     
  window.onload = () => {
    const reviewCards = document.querySelectorAll('.review-card');
    reviewCards.forEach((card) => {
      const order3 = card.querySelector('.order-3');
      const order2 = card.querySelector('.order-2');
      
      if(order3 && ((order3.classList.contains('client-review') && order2.classList.contains('client-info')) || (order3.classList.contains('client-info') && order2.classList.contains('client-review')))) {
        order2.style.marginTop = 'auto';
      } else if(order3 && !order3.classList.contains('client-message')) {
        order3.style.marginTop = 'auto';
      } else {
        if(!order2.classList.contains('client-message')) {
          order2.style.marginTop = 'auto';
        }  
      };
    });

    const child = document.querySelector('.swiper-slide-active');
    const parent = child.parentNode;
    const children = Array.from(parent.children);
    const index = Array.prototype.indexOf.call(children, child);
    
    children.forEach((child2) => {
      const childIndex = Array.prototype.indexOf.call(children, child2);
      if(childIndex > index) {
        child2.style.alignItems = 'end';
      } else if(childIndex < index) {
        child2.style.alignItems = 'start';
      } else {
        child2.style.alignItems = 'center';
      }
    });

    setInterval(function () {
      document.querySelector('#insta-feed').classList.add('insta-feed')
    }, 1200);
  };

  } catch(e) { console.error(e); }
})();
})();
